import { FetchPayload, FilterElement, FilterElementType, Pagination } from "./shared/fetch-request.model";

export class FetchSystemMessagesPayload extends FetchPayload {
  constructor(paginationLimit: number = 100, includeRelation: string[] = [], isLoggedInFilter = true) {
    const elementList: FilterElement[] = [
      {
        type: FilterElementType.FIELD,
        name: "SystemMessage",
      },
      {
        type: FilterElementType.SORT,
        name: "SystemMessage.insertTime",
        order: "desc",
      },
    ];
    if (isLoggedInFilter) {
      elementList.push(
        {
          type: FilterElementType.FIELD,
          name: "SystemMessage.showAfterPatientLogin",
          value: [true],
        });
    }
    const pagination: Pagination = {
      limit: paginationLimit, offset: 0,
    };
    super(elementList, pagination, includeRelation);
  }
}

